module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxn1XrJsKtwhNaJmMXegB1eg.woff2";